import React from "react";
import Sm from "../../images/Sm.png";
import P4 from "../../images/P4.png";
import P2 from "../../images/P2.png";
import P3 from "../../images/P3.png";
import P5 from "../../images/P5.png";

function FacebookPromotion() {
  return (
    <>
      <div>
        <h2 className="package_heading">Packages of Facebook boosting</h2>
      </div>
      <div className="row row-cols-1 row-cols-md-3">
        <div className="col mb-4 ">
          <div className="card package-box">
            <img src={Sm} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title ">Package-1</h5>
              <table className="table table-primary">
                <thead>
                  <tr>
                    <th scope="col">Budget</th>
                    <th scope="col">5 dollars </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Days </th>
                    <td>3 days</td>
                  </tr>
                  <tr>
                    <th scope="row">Cost</th>
                    <td>700 taka</td>
                  </tr>
                  <tr>
                    <th scope="row">Support</th>
                    <td>
                      <ul className="support">
                        <li>Target audience optimization</li>
                        <li>Boosting Content optimization </li>
                        <li>Providing report after boosting</li>
                        <li>Providing Page problem Guidline</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a
                href="https://m.me/ongshondigital"
                target="_blank"
                className="order-button"
              >
                Contact us
              </a>
            </div>
          </div>
        </div>
        <div className="col mb-4">
          <div className="card package-box">
            <img src={P2} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Package-2</h5>
              <table className="table table-success">
                <thead>
                  <tr>
                    <th scope="col">Budget</th>
                    <th scope="col">10 dollars </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Days </th>
                    <td>5 days</td>
                  </tr>
                  <tr>
                    <th scope="row">Cost</th>
                    <td>1400 taka</td>
                  </tr>
                  <tr>
                    <th scope="row">Support</th>
                    <td>
                      <ul className="support">
                        <li>Target audience optimization</li>
                        <li>Boosting Content optimization </li>
                        <li>Providing report after boosting</li>
                        <li>Providing Page problem Guidline</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a
                href="https://m.me/ongshondigital"
                target="_blank"
                className="order-button"
              >
                Contact us
              </a>
            </div>
          </div>
        </div>
        <div className="col mb-4">
          <div className="card package-box">
            <img src={P3} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Package-3</h5>
              <table className="table table-primary">
                <thead>
                  <tr>
                    <th scope="col">Budget</th>
                    <th scope="col">15 dollars </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Days </th>
                    <td>5 days</td>
                  </tr>
                  <tr>
                    <th scope="row">Cost</th>
                    <td>1900 taka</td>
                  </tr>
                  <tr>
                    <th scope="row">Support</th>
                    <td>
                      <ul className="support">
                        <li>Target audience optimization</li>
                        <li>Boosting Content optimization </li>
                        <li>Providing report after boosting</li>
                        <li>Providing Page problem Guidline</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a
                href="https://m.me/ongshondigital"
                target="_blank"
                className="order-button"
              >
                Contact us
              </a>
            </div>
          </div>
        </div>
        <div className="col mb-4">
          <div className="card package-box">
            <img src={P4} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Package-4</h5>
              <table className="table table-success">
                <thead>
                  <tr>
                    <th scope="col">Budget</th>
                    <th scope="col">15 dollars </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Days </th>
                    <td>7 days</td>
                  </tr>
                  <tr>
                    <th scope="row">Cost</th>
                    <td>2000 taka</td>
                  </tr>
                  <tr>
                    <th scope="row">Support</th>
                    <td>
                      <ul className="support">
                        <li>Target audience optimization</li>
                        <li>Boosting Content optimization </li>
                        <li>Providing report after boosting</li>
                        <li>Providing Page problem Guidline</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a
                href="https://m.me/ongshondigital"
                target="_blank"
                className="order-button"
              >
                Contact us
              </a>
            </div>
          </div>
        </div>
        <div className="col mb-4">
          <div className="card package-box">
            <img src={P5} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Package-5</h5>
              <table className="table table-primary">
                <thead>
                  <tr>
                    <th scope="col">Budget</th>
                    <th scope="col">7 dollars </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Days </th>
                    <td>4 days</td>
                  </tr>
                  <tr>
                    <th scope="row">Cost</th>
                    <td>1000 taka</td>
                  </tr>
                  <tr>
                    <th scope="row">Support</th>
                    <td>
                      <ul className="support">
                        <li>Target audience optimization</li>
                        <li>Boosting Content optimization </li>
                        <li>Providing report after boosting</li>
                        <li>Providing Page problem Guidline</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a
                href="https://m.me/ongshondigital"
                target="_blank"
                className="order-button"
              >
                Contact us
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default FacebookPromotion;
